module.exports = __webpack_public_path__ + "static/008636-a9c04901dd05b0a42586f983a8de893a.jpg";